"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M23.505 15.87c.243 0 .445.174.487.405l.008.088v5.555c0 1.098-.854 2-1.933 2.077l-.149.005H2.082c-1.098 0-2-.854-2.077-1.933L0 21.918v-5.555a.494.494 0 0 1 .982-.088l.008.088v5.555c0 .562.427 1.027.973 1.087l.119.006h19.836c.563 0 1.027-.427 1.087-.974l.006-.119v-5.555c0-.273.221-.494.494-.494ZM11.999 0c.063 0 .125.013.185.037.027.01.05.032.075.047l.04.021.036.026 5.158 4.76a.495.495 0 0 1-.601.782l-.07-.054-4.328-3.994v14.739a.495.495 0 0 1-.982.089l-.008-.09V1.626L7.177 5.619a.495.495 0 0 1-.73-.661l.06-.066L11.663.13c.023-.021.05-.031.076-.047.025-.015.048-.036.075-.047A.496.496 0 0 1 12 0Z",
    clipRule: "evenodd"
  })]
});